import { clamp } from "tsparticles-engine";
function checkDestroy(particle, value, minValue, maxValue) {
  switch (particle.options.opacity.animation.destroy) {
    case "max":
      if (value >= maxValue) {
        particle.destroy();
      }
      break;
    case "min":
      if (value <= minValue) {
        particle.destroy();
      }
      break;
  }
}
export function updateOpacity(particle, delta) {
  var _data$maxLoops, _data$loops, _data$maxLoops2, _data$decay, _data$delayTime, _data$delayTime2, _data$delayTime3, _data$delayTime4;
  const data = particle.opacity;
  if (particle.destroyed || !(data !== null && data !== void 0 && data.enable) || ((_data$maxLoops = data.maxLoops) !== null && _data$maxLoops !== void 0 ? _data$maxLoops : 0) > 0 && ((_data$loops = data.loops) !== null && _data$loops !== void 0 ? _data$loops : 0) > ((_data$maxLoops2 = data.maxLoops) !== null && _data$maxLoops2 !== void 0 ? _data$maxLoops2 : 0)) {
    return;
  }
  const minValue = data.min,
    maxValue = data.max,
    decay = (_data$decay = data.decay) !== null && _data$decay !== void 0 ? _data$decay : 1;
  if (!data.time) {
    data.time = 0;
  }
  if (((_data$delayTime = data.delayTime) !== null && _data$delayTime !== void 0 ? _data$delayTime : 0) > 0 && data.time < ((_data$delayTime2 = data.delayTime) !== null && _data$delayTime2 !== void 0 ? _data$delayTime2 : 0)) {
    data.time += delta.value;
  }
  if (((_data$delayTime3 = data.delayTime) !== null && _data$delayTime3 !== void 0 ? _data$delayTime3 : 0) > 0 && data.time < ((_data$delayTime4 = data.delayTime) !== null && _data$delayTime4 !== void 0 ? _data$delayTime4 : 0)) {
    return;
  }
  switch (data.status) {
    case "increasing":
      if (data.value >= maxValue) {
        data.status = "decreasing";
        if (!data.loops) {
          data.loops = 0;
        }
        data.loops++;
      } else {
        var _data$velocity;
        data.value += ((_data$velocity = data.velocity) !== null && _data$velocity !== void 0 ? _data$velocity : 0) * delta.factor;
      }
      break;
    case "decreasing":
      if (data.value <= minValue) {
        data.status = "increasing";
        if (!data.loops) {
          data.loops = 0;
        }
        data.loops++;
      } else {
        var _data$velocity2;
        data.value -= ((_data$velocity2 = data.velocity) !== null && _data$velocity2 !== void 0 ? _data$velocity2 : 0) * delta.factor;
      }
      break;
  }
  if (data.velocity && data.decay !== 1) {
    data.velocity *= decay;
  }
  checkDestroy(particle, data.value, minValue, maxValue);
  if (!particle.destroyed) {
    data.value = clamp(data.value, minValue, maxValue);
  }
}